import { AddressSearchResponse } from '@modules/addresses-store/client/src';
import { toLocalAddressSuggestion } from '@modules/addresses-store/util/address-suggestion.util';
import { IAddressSuggestion } from '@nx-ng/types';

export const formatAddressSearchResults = (
  searchResponse: AddressSearchResponse
): IAddressSuggestion[] => {
  if (
    searchResponse?.searchResults === undefined ||
    searchResponse.searchResults.length === 0
  ) {
    return [];
  }
  return searchResponse.searchResults
    .map((r) => toLocalAddressSuggestion(r))
    .filter((item): item is IAddressSuggestion => !!item);
};
